module.exports = __webpack_public_path__ + "img/vip4.025c6fba.png";